import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetStatistics = (params) => api.get(apiUrl.stats, { params });
